module.exports = __webpack_public_path__ + "img/order-sth.94e25350.png";